import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
const SelectBuilder = class {
  constructor(params, state, updateValue, eventBus) {
    var _a, _b, _c, _d, _e;
    this.params = params;
    this.state = state;
    this.updateValue = updateValue;
    this.eventBus = eventBus;
    this.extraLists = {};
    // буферы данных
    this.searchTextBuffer = '';
    this.applyValueSingleBuffer = '';
    this.applyValueMultipleBuffer = [];
    this.isDropdownOpenBuffer = false;
    this.defaultDropdownId = 123456789;
    // первичные опции билдера. Этот объект нужен для того чтобы на основе его значений определить значения по-умолчанию в финальном объекте "options"
    this.preOptions = Object.assign(Object.assign({ id: this.defaultDropdownId, buttonTextFunc: () => 'You need to set button text func', buttonTextFuncHTML: () => 'You need to set button text-HTML func', placeholder: '', searchCount: 7, 
      // список имен для дополнительных списков опций. Например, если мы передадим ['my-list'] и у каких-то опций зададим {list: 'my-list'}, то эти опции будут отображены в отдельном списке
      extraLists: [], apply: false, toggle: false, add: false, reflectColor: false }, this.params), { popupStyle: Object.assign({ '--ispui-dropdown-max-width': '500px', '--ispui-dropdown-min-width': '280px', '--ispui-dropdown-min-height': '10px', '--ispui-dropdown-popup__container_min-height': '10px', '--ispui-dropdown-content-min-height': '10px', '--ispui-dropdown-content-padding': '0px', '--ispui-dropdown-content-pr': '0px', '--ispui-dropdown-content-display': 'block' }, this.params.popupStyle) });
    this.dropdownClass = `ispui-select-dropdown-${(_a = this.preOptions.id) !== null && _a !== void 0 ? _a : 'no-id'}`;
    // В объекте "options" у нас есть поля $dropdown, $list и т.д. - это параметры для прямой передачи в эти элементы.
    // Но так как у нас могут быть дополнительные списки опций (из параметра extraLists), то нам нужно сгенерировать такие же объекты для них, т.е. если у нас параметр extraLists равен ['name1', 'name2'], то мы генерируем $list-nalme1, $list-name2 и т.д.
    this.extraListsParams = this.preOptions.extraLists.reduce((acc, listName) => {
      var _a, _b;
      const propName = `$list-${listName}`;
      acc[propName] = Object.assign(Object.assign({}, this.params[propName]), { ref: el => (this.extraLists[listName] = el), arrowNavigation: false, list: this.getOptionsUI(listName), onOptionClick: (e) => this.handleOptionClick(e.detail), style: Object.assign(Object.assign({ marginTop: '20px' }, (_a = this.params.$list) === null || _a === void 0 ? void 0 : _a.style), (_b = this.params[propName]) === null || _b === void 0 ? void 0 : _b.style) });
      return acc;
    }, {});
    this.getButtonColorStyles = () => {
      let color = 'unset';
      if (this.preOptions.reflectColor && !this.state.multiple && this.state.value && this.state.options.length) {
        const selectedOption = this.state.options.find(o => o.value === this.state.value);
        if (selectedOption && selectedOption.color) {
          color = selectedOption.color;
        }
      }
      const result = {};
      ['--ispui-select-button__color', '--ispui-select-button-chip__color', '--ispui-select-button-legend__color', '--ispui-select-button-line__color'].forEach(prop => (result[prop] = color));
      return result;
    };
    this.initialButtonText = this.preOptions.buttonTextFunc(this.state, this.preOptions.placeholder);
    this.options = Object.assign(Object.assign(Object.assign(Object.assign({ button: 'default', animateButton: true, hideOnSelect: true, hideOnAddClick: true }, this.preOptions), { $dropdown: Object.assign(Object.assign({ offset: 10, alignment: 'start', isClose: false }, this.params.$dropdown), { popupClass: `${this.dropdownClass} ${(_c = (_b = this.params.$dropdown) === null || _b === void 0 ? void 0 : _b.popupClass) !== null && _c !== void 0 ? _c : ''}`, ref: el => (this.dropdown = el), onOpen: () => this.handleDropdownOpen(), onClose: () => this.handleDropdownClose(), onClosingStart: () => this.handleDropdownClosingStart(), onOpeningStart: () => this.handleDropdownOpeningStart() }), $button: Object.assign(Object.assign(Object.assign(Object.assign({ slot: 'anchor' }, this.params.$button), { style: Object.assign(Object.assign({}, (_d = this.params.$button) === null || _d === void 0 ? void 0 : _d.style), this.getButtonColorStyles()) }), (this.preOptions.button === 'search'
        ? null
        : {
          title: this.preOptions.buttonTextFunc(this.state, this.preOptions.placeholder),
        })), { disabled: this.state.disabled, onSearch: (e) => this.handleSearch(e.detail), onFocus: () => this.eventBus.emit({ name: 'focus' }), onBlur: () => this.eventBus.emit({ name: 'blur' }), text: this.preOptions.button === 'search' ? this.initialButtonText : this.preOptions.buttonTextFuncHTML(this.state, this.preOptions.placeholder, this.initialButtonText), ref: el => (this.button = el), onClick: (e) => {
          var _a;
          e.stopPropagation();
          if (!this.state.disabled) {
            document.body.click(); // this is for hiding one select while opening another one
            (_a = this.dropdown) === null || _a === void 0 ? void 0 : _a.click();
          }
        }, onKeydown: (e) => {
          var _a, _b;
          if (e.key === 'Enter' && !this.state.disabled && !this.isDropdownOpenBuffer) {
            (_a = this.dropdown) === null || _a === void 0 ? void 0 : _a.click();
            (_b = this.search) === null || _b === void 0 ? void 0 : _b.focusInput();
          }
        }, onClear: () => {
          this.handleClear();
        } }), $customContent: this.params.$customContent, $customSegments: this.params.$customSegments, $list: Object.assign(Object.assign({}, this.params.$list), { ref: el => (this.list = el), list: this.getOptionsUI(), onOptionHoverOn: () => this.eventBus.emit({ name: 'option-hover-on' }), onOptionHoverOff: () => this.eventBus.emit({ name: 'option-hover-off' }), onOptionNavigationOn: () => this.eventBus.emit({ name: 'option-navigation-on' }), onOptionNavigationOff: () => this.eventBus.emit({ name: 'option-navigation-off' }), onOptionClick: (e) => this.handleOptionClick(e.detail) }) }), this.extraListsParams), { $notFound: Object.assign(Object.assign({}, this.params.$notFound), { style: Object.assign({ fontFamily: '"Ubuntu", sans-serif', fontSize: '14px' }, (_e = this.params.$notFound) === null || _e === void 0 ? void 0 : _e.style), ref: el => (this.notFound = el), hidden: true }), $search: Object.assign(Object.assign({}, this.params.$search), { ref: el => (this.search = el), onSearch: (e) => this.handleSearch(e.detail), hidden: this.preOptions.searchCount === 0 || this.state.options.length < this.preOptions.searchCount }), $apply: Object.assign(Object.assign({}, this.params.$apply), { onApply: () => this.handleApply(), onReset: () => this.handleReset(), ref: el => (this.apply = el) }), $toggle: Object.assign(Object.assign({}, this.params.$toggle), { hidden: !this.state.multiple, checked: this.getCheckedStateForToggle(), partialSelected: !this.getCheckedStateForToggle(true), onToggle: () => this.handleToggle(), ref: el => (this.toggle = el) }), $add: Object.assign(Object.assign({}, this.params.$add), { onAddClick: () => this.handleAddClick(), ref: el => (this.add = el) }) });
    if (this.options.id === this.defaultDropdownId) {
      console.warn('ISPUI-select: missing required builder parameter "id". It might be a reason why ispui-select is not working.');
    }
    this.updateDropdownStyle();
    document.addEventListener('keydown', e => { var _a; return e.key === 'Escape' && this.isDropdownOpenBuffer && ((_a = this.dropdown) === null || _a === void 0 ? void 0 : _a.closeDropdown()); });
  }
  updateDropdownStyle() {
    var _a, _b;
    (_a = document.getElementById(this.dropdownClass)) === null || _a === void 0 ? void 0 : _a.remove();
    let popupStyle = '';
    for (const styleName in this.options.popupStyle) {
      popupStyle += `${styleName}: ${(_b = this.options.popupStyle[styleName]) !== null && _b !== void 0 ? _b : 'auto'};\n`;
    }
    document.head.insertAdjacentHTML('beforeend', `<style id='${this.dropdownClass}'>
        .${this.dropdownClass} {
          ${popupStyle}
        }
      </style>`);
  }
  updateList(listName) {
    const list = listName ? this.extraLists[listName] : this.list;
    if (list) {
      list.list = this.getOptionsUI(listName);
      list.checkbox = !!this.state.multiple && this.options.checkbox;
    }
  }
  updateLists() {
    this.updateList();
    this.options.extraLists.forEach(listName => this.updateList(listName));
  }
  handleAddClick() {
    var _a;
    this.eventBus.emit({ name: 'add-click' });
    if (this.options.hideOnAddClick) {
      (_a = this.dropdown) === null || _a === void 0 ? void 0 : _a.closeDropdown();
    }
  }
  handleToggle() {
    const isToggleAllOn = !this.getCheckedStateForToggle(true);
    // Notice - this method is only called when multiple === true, because if it is not, toggle hides
    const currentValue = this.getCurrentValueAsArray();
    if (this.options.apply) {
      this.applyValueMultipleBuffer = this.state.options
        .filter((option, i) => {
        var _a;
        const isInValue = currentValue.includes(option.value);
        return !((_a = this.list) === null || _a === void 0 ? void 0 : _a.list[i].hide) && !option.disabled && (isToggleAllOn ? !isInValue : isInValue);
      })
        .map(option => option.value);
      this.updateValue(this.state.value);
      return;
    }
    // Notice - we cannot just select or deselect all options, because there might be disabled (hidden) options (selected or not) and they should remain as they are
    const selectedValue = this.state.options
      .filter((option, i) => { var _a; return (!((_a = this.list) === null || _a === void 0 ? void 0 : _a.list[i].hide) && !option.disabled) || currentValue.includes(option.value); })
      .map(option => option.value);
    const deselectedValue = this.state.options
      .filter((option, i) => { var _a; return (((_a = this.list) === null || _a === void 0 ? void 0 : _a.list[i].hide) || option.disabled) && currentValue.includes(option.value); })
      .map(option => option.value);
    this.updateValue(isToggleAllOn ? selectedValue : deselectedValue);
    this.eventBus.emit({
      name: isToggleAllOn ? 'toggle-all-on' : 'toggle-all-off',
    });
  }
  handleApply() {
    var _a;
    let currentValue = this.state.value;
    if (this.state.multiple && typeof currentValue === 'string') {
      if (currentValue) {
        currentValue = [currentValue];
      }
      else {
        currentValue = [];
      }
    }
    let newValue;
    if (this.state.multiple) {
      const vSet = new Set(currentValue);
      this.applyValueMultipleBuffer.forEach(v => (vSet.has(v) ? vSet.delete(v) : vSet.add(v)));
      newValue = Array.from(vSet);
      this.applyValueMultipleBuffer = [];
    }
    else {
      newValue = this.applyValueSingleBuffer || currentValue;
      this.applyValueSingleBuffer = '';
    }
    (_a = this.dropdown) === null || _a === void 0 ? void 0 : _a.closeDropdown();
    this.updateValue(newValue);
    this.eventBus.emit({ name: 'apply' });
  }
  handleClear() {
    this.updateValue(this.state.multiple ? [] : '');
    this.eventBus.emit({ name: 'clear' });
  }
  handleReset() {
    this.applyValueSingleBuffer = '';
    this.applyValueMultipleBuffer = [];
    this.updateValue(this.state.value);
    this.eventBus.emit({ name: 'reset' });
  }
  getCheckedStateForToggle(isStrict = false) {
    if (!this.state.multiple) {
      return false;
    }
    const currentValue = this.getCurrentValueAsArray();
    const methodName = isStrict ? 'every' : 'some';
    const editableOptions = this.state.options.filter((option, i) => { var _a; return !((_a = this.list) === null || _a === void 0 ? void 0 : _a.list[i].hide) && !option.disabled; });
    // we check preOptions, not options, because this method is also called in options definition
    if (this.preOptions.apply) {
      const isOptionInStateValue = (option) => this.state.value.includes(option.value);
      const isOptionInBuffer = (option) => this.applyValueMultipleBuffer.includes(option.value);
      // if we have 'apply' enabled, the toggle should be 'on' if at least one option is selected, because in such case 'on' state will be shown with 'minus' icon (not 'check'), and it's action will be 'uncheck all checked options, even there is only one'
      return editableOptions[methodName](option => isOptionInStateValue(option) !== isOptionInBuffer(option));
    }
    return editableOptions[methodName](option => currentValue.includes(option.value));
  }
  handleStateUpdate() {
    var _a;
    if (this.search) {
      this.search.hidden = this.state.options.length < this.options.searchCount;
    }
    if (this.button) {
      const buttonText = this.options.buttonTextFunc(this.state, this.options.placeholder);
      this.button.disabled = this.state.disabled;
      this.button.asterisk = this.options.showRequiredInLegend && this.state.required;
      if (this.options.button !== 'search') {
        this.button.title = buttonText;
      }
      this.button.text = this.preOptions.button === 'search' ? buttonText : this.options.buttonTextFuncHTML(this.state, this.options.placeholder, buttonText);
      if (this.options.reflectColor) {
        const styles = this.getButtonColorStyles();
        for (const prop in styles) {
          this.button.style.setProperty(prop, styles[prop]);
        }
      }
    }
    if (this.state.disabled) {
      (_a = this.dropdown) === null || _a === void 0 ? void 0 : _a.closeDropdown();
    }
    this.updateLists();
    if (this.options.toggle && this.toggle) {
      this.toggle.hidden = !this.state.multiple;
      this.toggle.checked = this.getCheckedStateForToggle();
      this.toggle.partialSelected = !this.getCheckedStateForToggle(true);
    }
  }
  handleSearch(text) {
    var _a;
    this.searchTextBuffer = text;
    if (this.notFound) {
      this.notFound.hidden = text === '' || ((_a = this.list) === null || _a === void 0 ? void 0 : _a.list.some(option => !option.hide));
    }
    this.handleStateUpdate();
    setTimeout(() => { var _a; return (_a = this.dropdown) === null || _a === void 0 ? void 0 : _a.setupDropdown(); }, 100);
    this.eventBus.emit({ name: 'search', data: text });
  }
  handleDropdownOpen() {
    this.isDropdownOpenBuffer = true;
    if (this.options.animateButton && this.button) {
      this.button.open = true;
    }
    this.eventBus.emit({ name: 'dropdown-open' });
  }
  handleDropdownClose() {
    var _a;
    this.isDropdownOpenBuffer = false;
    if (this.search) {
      this.search.value = '';
    }
    (_a = this.list) === null || _a === void 0 ? void 0 : _a.clearNavigation();
    this.eventBus.emit({ name: 'dropdown-close' });
  }
  async handleDropdownClosingStart() {
    if (this.button && !this.button.disabled) {
      this.button.open = false;
      const activeElement = document.activeElement;
      // If focus leaves from focusable elements and dropdown closing then return focus to anchor button
      const dropdownPopup = await this.dropdown.getPopup();
      if ((dropdownPopup === null || dropdownPopup === void 0 ? void 0 : dropdownPopup.contains(activeElement)) || (activeElement === null || activeElement === void 0 ? void 0 : activeElement.tagName.toLowerCase()) === 'body') {
        this.button.focus();
      }
    }
    this.eventBus.emit({ name: 'dropdown-closing-start' });
  }
  handleDropdownOpeningStart() {
    this.eventBus.emit({ name: 'dropdown-opening-start' });
  }
  handleOptionClick(option) {
    var _a;
    if (option.disabled) {
      return;
    }
    this.eventBus.emit({
      name: 'option-click',
      data: option,
    });
    if (!this.state.multiple && this.options.hideOnSelect) {
      (_a = this.dropdown) === null || _a === void 0 ? void 0 : _a.closeDropdown();
    }
    if (this.options.apply) {
      if (this.state.multiple) {
        if (this.applyValueMultipleBuffer.includes(option.value)) {
          this.applyValueMultipleBuffer = this.applyValueMultipleBuffer.filter(v => v !== option.value);
        }
        else {
          this.applyValueMultipleBuffer.push(option.value);
        }
      }
      else {
        this.applyValueSingleBuffer = option.value;
      }
      this.updateValue(this.state.value);
      return;
    }
    const currentValue = this.getCurrentValueAsArray();
    let newValue;
    if (this.state.multiple) {
      if (currentValue.includes(option.value)) {
        newValue = currentValue.filter(v => v !== option.value);
      }
      else {
        newValue = [...currentValue, option.value];
      }
    }
    else {
      newValue = option.value;
    }
    this.updateValue(newValue);
  }
  /** return current state.value as array */
  getCurrentValueAsArray() {
    if (Array.isArray(this.state.value)) {
      return this.state.value;
    }
    const result = [];
    if (typeof this.state.value === 'string' && this.state.value) {
      result.push(this.state.value);
    }
    return result;
  }
  // return OptionsUI calculated only from select value (without considering search, apply, extraLists etc.)
  getRawOptionsUI() {
    return this.state.options.map(option => {
      return Object.assign(Object.assign({}, option), { selected: Array.isArray(this.state.value) ? this.state.value.includes(option.value) : this.state.value === option.value, navigated: false, searchTerm: '', hide: false, textHtml: option.text });
    });
  }
  // set "select" properties according to the apply buffer
  selectOptionsAccordingToApplyBuffer(list) {
    if (!this.preOptions.apply) {
      return;
    }
    const inStateValue = (value) => this.state.value.includes(value);
    const inBufferValue = (value) => this.applyValueMultipleBuffer.includes(value);
    const visualMultipleValue = list.map(option => option.value).filter(value => inStateValue(value) !== inBufferValue(value));
    const visualSingleValue = this.applyValueSingleBuffer || this.state.value;
    list.forEach((option) => {
      option.selected = this.state.multiple ? visualMultipleValue.includes(option.value) : visualSingleValue === option.value;
    });
  }
  // highlight and hide options according to current search value
  reflectSearchInOptions(list) {
    if (this.searchTextBuffer) {
      list.forEach((option) => {
        option.searchTerm = this.searchTextBuffer;
        const reNeedle = new RegExp(escapeRegExp(this.searchTextBuffer), 'i');
        if (reNeedle.test(option.textHtml)) {
          option.textHtml = option.textHtml.replace(reNeedle, '<span class="ispui-select-list__item-search-match">$&</span>');
        }
        else {
          option.hide = true;
        }
      });
    }
  }
  // get final option list for passing to a certain list component
  getOptionsUI(listName) {
    const rawOptions = this.getRawOptionsUI();
    const listOptions = listName ? rawOptions.filter(option => option.list === listName) : rawOptions.filter(option => !option.list);
    this.selectOptionsAccordingToApplyBuffer(listOptions);
    if (listName === undefined) {
      this.reflectSearchInOptions(listOptions);
    }
    return listOptions;
  }
  getTree() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    let dropdownContent;
    if (this.options.$customContent) {
      dropdownContent = [this.options.$customContent];
    }
    else {
      // features with the same component name patterns - <ispui-select-[feature]/>, so we can generate content by iterating feature names
      const hasFeatures = {
        search: this.options.button !== 'search',
        toggle: this.options.toggle,
        list: true,
        add: this.options.add,
        apply: this.options.apply,
      };
      const feachureNodes = {};
      ['search', 'toggle', 'list', 'add', 'apply'].forEach(featureName => {
        var _a, _b, _c, _d;
        feachureNodes[featureName] = [];
        if (hasFeatures[featureName]) {
          feachureNodes[featureName].push(((_b = (_a = this.options.$customSegments) === null || _a === void 0 ? void 0 : _a[`$${featureName}`]) === null || _b === void 0 ? void 0 : _b.before) || null, {
            tag: `ispui-select-${featureName}`,
            params: this.options[`$${featureName}`],
          }, ((_d = (_c = this.options.$customSegments) === null || _c === void 0 ? void 0 : _c[`$${featureName}`]) === null || _d === void 0 ? void 0 : _d.after) || null);
        }
      });
      const beginNode = ((_b = (_a = this.options.$customSegments) === null || _a === void 0 ? void 0 : _a.$all) === null || _b === void 0 ? void 0 : _b.before) || null;
      const notFoundNodes = [
        ((_d = (_c = this.options.$customSegments) === null || _c === void 0 ? void 0 : _c.$notFound) === null || _d === void 0 ? void 0 : _d.before) || null,
        { tag: 'div', params: this.options.$notFound },
        ((_f = (_e = this.options.$customSegments) === null || _e === void 0 ? void 0 : _e.$notFound) === null || _f === void 0 ? void 0 : _f.after) || null,
      ];
      const extraListNodes = [];
      this.options.extraLists.forEach(listName => {
        var _a, _b;
        extraListNodes.push(this.options.$customSegments ? ((_a = this.options.$customSegments[`$list-${listName}`]) === null || _a === void 0 ? void 0 : _a.before) || null : null, {
          tag: 'ispui-select-list',
          params: this.options[`$list-${listName}`],
        }, this.options.$customSegments ? ((_b = this.options.$customSegments[`$list-${listName}`]) === null || _b === void 0 ? void 0 : _b.after) || null : null);
      });
      const endNode = ((_h = (_g = this.options.$customSegments) === null || _g === void 0 ? void 0 : _g.$all) === null || _h === void 0 ? void 0 : _h.after) || null;
      dropdownContent = [
        beginNode,
        ...feachureNodes.search,
        ...feachureNodes.toggle,
        ...feachureNodes.list,
        ...notFoundNodes,
        ...extraListNodes,
        ...feachureNodes.add,
        ...feachureNodes.apply,
        endNode,
      ];
    }
    return {
      tag: 'ispui-dropdown',
      params: this.options.$dropdown,
      children: [
        {
          tag: this.options.button === 'default' ? 'ispui-select-button' : `ispui-select-button-${(_j = this.options.button) !== null && _j !== void 0 ? _j : ''}`,
          params: this.options.$button,
        },
        {
          tag: 'ispui-dropdown-content',
          children: dropdownContent,
        },
      ],
    };
  }
};

const buttonTextFunc = (state, placeholder) => {
  var _a;
  if (state.multiple) {
    let currentValue = state.value;
    if (typeof currentValue === 'string') {
      currentValue = [currentValue];
    }
    return (state.options
      .filter(o => currentValue.includes(o.value))
      .map(o => o.text)
      .join(', ') || placeholder);
  }
  else {
    return ((_a = state.options.find(o => o.value === state.value)) === null || _a === void 0 ? void 0 : _a.text) || placeholder;
  }
};
const SelectBuilderDecorator = class {
  constructor(params, state, updateValue, eventBus) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    this.params = params;
    this.state = state;
    this.updateValue = updateValue;
    this.eventBus = eventBus;
    this.width = ['default', 'search', 'legend'].includes(this.params.appearance) || !this.params.appearance ? '280px' : '230px';
    this.preOptions = Object.assign({ appearance: 'default', width: this.width, maxWidth: this.width, placeholder: '', searchCount: 7, // set 0 to disable search
      buttonTextFunc, buttonTextFuncHTML: this.params.buttonTextFunc || buttonTextFunc, reflectColor: false, button: this.params.legend ? 'legend' : this.params.appearance === 'line-vmdci' ? 'line' : this.params.appearance || 'default', legend: '', showRequiredInLegend: true, focusVisible: this.params.appearance === undefined || this.params.appearance !== 'line-vmdci', extraLists: [], itemArea: this.params.appearance === 'line-vmdci' ? 'text' : 'full', hideOnSelect: true, checkbox: true, selectedHighlight: false, hoverHighlight: this.params.appearance !== 'line-vmdci', selectedBold: true, emitOptionNavigation: false, emitOptionHover: false, notFoundText: 'Не найдено', applyText: 'Применить', resetText: 'Сбросить', toggleOnText: 'Выбрать всё', toggleOffText: 'Снять выбор', addText: 'Добавить', addTheme: ['chip', 'line', 'line-vmdci'].includes(this.params.appearance) ? 'vmdci' : 'default', hideOnAddClick: true }, this.params);
    this.offsetX = this.preOptions.appearance === 'line-vmdci' ? 0 : 20;
    this.offsetY = this.preOptions.appearance === 'line-vmdci' ? 0 : 20;
    this.defaultDropdownId = 123456789;
    this.options = Object.assign(Object.assign({ id: this.defaultDropdownId, apply: this.params.reset !== undefined || this.params.applyText !== undefined || this.params.resetText !== undefined ? true : false, reset: this.params.resetText !== undefined ? true : false, toggle: this.params.toggleOnText || this.params.toggleOffText ? true : false, add: this.params.addText || this.params.addTheme ? true : false }, this.preOptions), { popupStyle: Object.assign(Object.assign({}, this.getPopupStyle()), this.preOptions.popupStyle), $dropdown: Object.assign({ hasPointer: ['chip', 'line'].includes(this.preOptions.appearance), alignment: ['chip', 'line'].includes(this.preOptions.appearance) ? 'auto' : 'start' }, this.preOptions.$dropdown), $button: Object.assign(Object.assign({ legend: this.preOptions.legend, 
        // for ispui-select-button-legend
        asterisk: this.preOptions.showRequiredInLegend && this.state.required, focusVisible: this.preOptions.focusVisible, displayClear: false }, this.preOptions.$button), { style: Object.assign({ '--ispui-select-button__width': this.preOptions.width ? this.preOptions.width : 'auto', '--ispui-select-button-search__width': this.preOptions.width ? this.preOptions.width : 'auto', '--ispui-select-button-legend__width': this.preOptions.width ? this.preOptions.width : 'auto' }, (_a = this.preOptions.$button) === null || _a === void 0 ? void 0 : _a.style) }), $anchor: Object.assign(Object.assign({}, this.preOptions.$anchor), { style: Object.assign(Object.assign({}, this.getAnchorStyle()), (_b = this.preOptions.$anchor) === null || _b === void 0 ? void 0 : _b.style) }), $customContent: this.preOptions.$customContent, $customSegments: this.preOptions.$customSegments, $list: Object.assign(Object.assign({ itemArea: this.preOptions.itemArea, hideOnSelect: this.preOptions.hideOnSelect, checkbox: this.preOptions.checkbox && this.state.multiple, selectedHighlight: this.preOptions.selectedHighlight, hoverHighlight: this.preOptions.hoverHighlight, selectedBold: this.preOptions.selectedBold, emitHoverOn: this.preOptions.emitOptionHover, emitHoverOff: this.preOptions.emitOptionHover, emitNavigationOn: this.preOptions.emitOptionNavigation, emitNavigationOff: this.preOptions.emitOptionNavigation }, this.preOptions.$list), { style: Object.assign({ 
          // 10 is a list item paddingLeft
          marginLeft: `${this.offsetX - 10}px`, marginRight: `${this.offsetX}px` }, (_c = this.preOptions.$list) === null || _c === void 0 ? void 0 : _c.style) }), $search: Object.assign(Object.assign({}, this.preOptions.$search), { style: Object.assign({ padding: `0 ${this.offsetX}px`, marginBottom: '15px' }, (_d = this.preOptions.$search) === null || _d === void 0 ? void 0 : _d.style) }), $notFound: Object.assign(Object.assign({ innerHTML: this.preOptions.notFoundText }, this.preOptions.$notFound), { style: Object.assign({ padding: `0 ${this.offsetX}px` }, (_e = this.preOptions.$notFound) === null || _e === void 0 ? void 0 : _e.style) }), $apply: Object.assign(Object.assign({ withReset: this.preOptions.reset, applyText: this.preOptions.applyText, resetText: this.preOptions.resetText }, this.preOptions.$apply), { style: Object.assign({ padding: `0 ${this.offsetX}px`, marginTop: '24px' }, (_f = this.preOptions.$apply) === null || _f === void 0 ? void 0 : _f.style) }), $toggle: Object.assign(Object.assign({ onText: this.preOptions.toggleOnText, offText: this.preOptions.toggleOffText }, this.preOptions.$toggle), { style: Object.assign({ padding: `0 ${this.offsetX}px 15px`, marginBottom: '10px', borderBottom: '1px solid #D9D9D9' }, (_g = this.preOptions.$toggle) === null || _g === void 0 ? void 0 : _g.style) }), $add: Object.assign(Object.assign({ theme: this.preOptions.addTheme, text: this.preOptions.addText }, this.preOptions.$add), { style: Object.assign({ padding: `8px ${this.offsetX}px 0 ${this.offsetX - (this.preOptions.addTheme === 'vmdci' ? 3 : 0)}px` }, (_h = this.preOptions.$add) === null || _h === void 0 ? void 0 : _h.style) }) });
    this.builder = new SelectBuilder(this.options, state, updateValue, eventBus);
  }
  getAnchorStyle() {
    const app = this.preOptions.appearance;
    if (['default', 'search', 'legend'].includes(app)) {
      return null;
    }
    if (app === 'line-vmdci') {
      return { left: 'calc(100% - 10px)', bottom: '100%' };
    }
    return {
      bottom: '-20px',
      left: `calc(100% - ${app === 'chip' ? 12 : 7}px)`,
    };
  }
  getPopupStyle() {
    return Object.assign({ '--ispui-dropdown-content-padding': `${this.offsetY}px 0`, '--ispui-dropdown-min-width': this.preOptions.width ? this.preOptions.width : 'auto', '--ispui-dropdown-max-width': this.preOptions.maxWidth ? this.preOptions.maxWidth : 'auto' }, (this.preOptions.appearance === 'line-vmdci' ? { '--ispui-dropdown-border-radius': '0' } : null));
  }
  handleStateUpdate() {
    this.builder.handleStateUpdate();
  }
  getTree() {
    return this.builder.getTree();
  }
};

const Select = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.change = createEvent(this, "change", 7);
    this.internalAction = createEvent(this, "internalAction", 7);
    this.focus = createEvent(this, "focus", 7);
    this.blur = createEvent(this, "blur", 7);
    /** builder class giving content to render */
    this.builder = SelectBuilderDecorator;
    /** prev builder constructor class */
    this.prevBuilder = this.builder;
    /** params for builder */
    this.builderParams = {};
    /** prev builder params */
    this.prevBuilderParams = this.builderParams;
    /** options */
    this.options = [];
    /** value */
    this.value = '';
    /** prev select value */
    this.oldValue = this.value;
    /** disabled */
    this.disabled = false;
    /** multiple */
    this.multiple = false;
    /** required */
    this.required = false;
    this.state = {
      options: this.options,
      value: this.value,
      disabled: this.disabled,
      multiple: this.multiple,
      required: this.required,
    };
    /** is the last value set as a fallback (empty string) */
    this.isValueFallback = false;
    /** is the last value updated by user in UI */
    this.isValueSetFromUI = false;
    this.bus = {
      emit: event => {
        let isEmit = true;
        switch (event.name) {
          case 'focus':
            this.focus.emit();
            isEmit = false;
            break;
          case 'blur':
            this.blur.emit();
            isEmit = false;
            break;
          default:
            break;
        }
        if (isEmit) {
          this.internalAction.emit(event);
        }
      },
    };
  }
  onValueParamUpdate(_, oldValue) {
    if (typeof oldValue === 'string' || Array.isArray(oldValue)) {
      this.oldValue = oldValue;
    }
  }
  onBulderParamChange(_, oldVal) {
    this.prevBuilder = oldVal;
  }
  onBulderParamsParamChange(_, oldVal) {
    this.prevBuilderParams = oldVal;
  }
  tellBuilderThatStateHasUpdated() {
    var _a;
    (_a = this.builderInstance) === null || _a === void 0 ? void 0 : _a.handleStateUpdate();
  }
  recreateBuilder() {
    const Builder = this.builder || SelectBuilderDecorator;
    this.builderInstance = new Builder(this.builderParams, this.state, this.updateValue.bind(this), this.bus);
    // save current builder and builder params to prevent any further builder recreation
    this.prevBuilder = this.builder;
    this.prevBuilderParams = this.builderParams;
  }
  handleValueParameter(newVal, oldVal) {
    if (this.isValueValid(newVal)) {
      const isSame = this.areValuesTheSame(newVal, oldVal);
      if (isSame) {
        // even if the value is the same as previous - if it's updated from UI (i.e. builder) it should update state. Builder may update value just to rerender
        if (this.isValueSetFromUI) {
          this.state.value = newVal;
          this.tellBuilderThatStateHasUpdated();
        }
      }
      else {
        if (this.isValueFallback) {
          this.isValueFallback = false;
        }
        else {
          this.change.emit({ value: this.value, isFromUI: this.isValueSetFromUI });
        }
        this.state.value = newVal;
        this.tellBuilderThatStateHasUpdated();
      }
      this.isValueSetFromUI = false;
      this.oldValue = this.value;
    }
    else {
      this.isValueFallback = true;
      this.isValueSetFromUI = false;
      this.handleValueParameter(oldVal, this.value);
    }
  }
  areValuesTheSame(val1, val2) {
    let result = val1 === val2;
    if (Array.isArray(val1) && Array.isArray(val2)) {
      result = val1.sort().join() == val2.sort().join();
    }
    return result;
  }
  isValueValid(val) {
    if (this.multiple) {
      return typeof val === 'string' || (Array.isArray(val) && val.every(v => typeof v === 'string'));
    }
    else {
      return typeof val === 'string';
    }
  }
  componentWillLoad() {
    this.state.options = this.options;
    this.state.disabled = this.disabled;
    this.state.multiple = this.multiple;
    this.state.required = this.required;
    let prevValue;
    if (this.multiple) {
      prevValue = typeof this.oldValue === 'string' || Array.isArray(this.oldValue) ? this.oldValue : '';
    }
    else {
      prevValue = typeof this.oldValue === 'string' ? this.oldValue : '';
    }
    this.handleValueParameter(this.value, prevValue);
    this.recreateBuilder();
  }
  componentWillUpdate() {
    if (this.prevBuilder !== this.builder || this.prevBuilderParams !== this.builderParams) {
      this.recreateBuilder();
    }
    this.state.options = this.options;
    this.state.disabled = this.disabled;
    this.state.multiple = this.multiple;
    this.state.required = this.required;
    this.tellBuilderThatStateHasUpdated();
    if (this.value !== this.oldValue) {
      this.handleValueParameter(this.value, this.oldValue);
    }
  }
  /** Update value in state and also, if it's different from previous, in value parameter */
  updateValue(value) {
    this.isValueSetFromUI = true;
    // if we update the value parameter with the same content, @watch for it won't fire, but the state still should be updated
    if (value === this.value) {
      this.tellBuilderThatStateHasUpdated();
    }
    this.oldValue = this.value;
    this.value = value;
    this.handleValueParameter(this.value, this.oldValue);
  }
  render() {
    const subrender = (node) => {
      var _a;
      if (!node) {
        return null;
      }
      return h(node.tag, Object.assign({}, node.params), (_a = node.children) === null || _a === void 0 ? void 0 : _a.map(subrender));
    };
    return subrender(this.builderInstance.getTree());
  }
  static get watchers() { return {
    "value": ["onValueParamUpdate"],
    "builder": ["onBulderParamChange"],
    "builderParams": ["onBulderParamsParamChange"]
  }; }
}, [0, "ispui-select", {
    "builder": [16],
    "builderParams": [16],
    "options": [16],
    "value": [1025],
    "disabled": [4],
    "multiple": [4],
    "required": [4],
    "builderInstance": [32]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["ispui-select"];
  components.forEach(tagName => { switch (tagName) {
    case "ispui-select":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, Select);
      }
      break;
  } });
}

const IspuiSelect = Select;
const defineCustomElement = defineCustomElement$1;

export { IspuiSelect, SelectBuilder as S, SelectBuilderDecorator as a, defineCustomElement };
